import { Component, Input } from '@angular/core';

@Component({
  selector: 'pdfTemplate',
  template: `<div style="height: 5000; width: 4500;"[ngSwitch]="templateType">
    <receipt *ngSwitchCase="'receipt'" [pdfModel]="pdfModel"></receipt>
  </div>`
})
export class TemplateSelectorComponent  {
  @Input("templateType") templateType: string;
  @Input("pdfModel") pdfModel: any;

  ngOnInit(){
    var bumm = this.pdfModel;
    var templar = this.templateType;
  }

  ngOnChanges(){
    var bumm = this.pdfModel;
    var templar = this.templateType;
  }
}
